import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import BuildingTripLoader from './BuildingTripLoader';
import * as api from '../api';
import * as analytics from '../analytics';

function BuildTrip({ country, cities, days, onBack, onReset, onTripBuilt, preserveCityOrder = false }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleBuildTrip = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    const startTime = Date.now();

    // Track build started
    analytics.trackBuildTripStarted({
      countryId: country ? Number(country) : 0,
      cityCount: cities.length,
      days: days,
    });

    try {
      const data = await api.buildTrip({
        country_id: country ? Number(country) : null,
        city_ids: cities.length > 0 ? cities.map(Number) : [],
        duration_in_days: days || null,
        budget: null,
        total_travelers: null,
        cuisine_type: [],
        activity_type: [],
        preserve_city_order: preserveCityOrder,
      });

      // Track build completed
      const duration = Date.now() - startTime;
      analytics.trackBuildTripCompleted(data.trip?.id || 0, duration);

      setSuccess(true);
      onTripBuilt(data);
    } catch (err) {
      console.error('Error building trip:', err);
      analytics.trackBuildTripFailed(err instanceof Error ? err.message : 'Unknown error');
      setError(err.message);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Trip Summary</Typography>
      <Typography>Country ID: {country}</Typography>
      <Typography>Cities: {cities.join(', ')}</Typography>
      <Typography>Days: {days}</Typography>
      <Box mt={3} display="flex" gap={2}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" color="primary" onClick={handleBuildTrip} disabled={loading}>
          Build Trip
        </Button>
        <Button onClick={onReset} color="secondary">Start Over</Button>
      </Box>
      <BuildingTripLoader open={loading} />
      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Trip built successfully! Moving to itinerary...
        </Alert>
      )}
      <Snackbar
        open={!!error && openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default BuildTrip; 